import React, { ReactNode } from 'react';

import { twMerge } from 'tailwind-merge';
import RouteLink from 'flow/components/ui-components/RouteLink';

interface Props {
    description?: ReactNode;
    className?: string;
    dataTestId?: string;
    children: ReactNode;
}
interface EditableItemProps extends Props {
    editable: true;
    to: string;
}
interface NonEditableItemProps extends Props {
    editable?: false;
    to?: string;
}

const SettingsListItem = ({
    editable,
    description = '',
    className,
    children,
    to,
    dataTestId,
}: EditableItemProps | NonEditableItemProps) => {
    if (editable) {
        return (
            <RouteLink to={to} description={description}>
                {children}
            </RouteLink>
        );
    }
    return (
        <div>
            <div
                className={twMerge(
                    'flex w-full items-center justify-between rounded-sm px-2 py-4 hover:bg-gray-100',
                    className,
                )}
                data-test-id={dataTestId}
            >
                <div className="flex items-center gap-x-3">{children}</div>
                <div className="flex items-center">
                    <div className="text-sm text-gray-500">{description}</div>
                </div>
            </div>
        </div>
    );
};

export default SettingsListItem;
